import React from "react";

const UnreadAlert = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none">
    <circle cx="3" cy="3" r="3" fill="#FAE395" />
  </svg>
);

export default UnreadAlert;
